const state = {
    labour: [],
    loading: false
};

export default state;